import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import SpeakolInput from './components/SpeakolInput.vue'
import SpeakolSelect from './components/SpeakolSelect.vue'
import SpeakolTreeSelect from './components/SpeakolTreeSelect.vue'
import SpeakolSummaryCard from './components/SpeakolSummaryCard.vue'
import SpeakolDateRangePicker from './components/SpeakolDateRangePicker.vue'
import SpeakolCheckboxTree from './components/SpeakolCheckboxTree.vue'
import SpeakolAsyncCheckboxTree from './components/SpeakolAsyncCheckboxTree.vue'
import SpeakolAnalyticsCard from './components/SpeakolAnalyticsCard.vue'
import SpeakolConfirmationPopup from './components/popups/SpeakolConfirmationPopup.vue'
import SpeakolResponsePopup from './components/popups/SpeakolResponsePopup.vue'
import SpeakolBiddingConfirmationPopup from './components/popups/bidding_confirmation_popup/index.vue'
import SpeakolChoroplethMap from './components/SpeakolChoroplethMap/index.vue'
import SpeakolChartFilter from './components/SpeakolChartFilter/index.vue'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(SpeakolInput.name, SpeakolInput)
Vue.component(SpeakolSelect.name, SpeakolSelect)
Vue.component(SpeakolTreeSelect.name, SpeakolTreeSelect)
Vue.component(SpeakolSummaryCard.name, SpeakolSummaryCard)
Vue.component(SpeakolDateRangePicker.name, SpeakolDateRangePicker)
Vue.component(SpeakolCheckboxTree.name, SpeakolCheckboxTree)
Vue.component(SpeakolAsyncCheckboxTree.name, SpeakolAsyncCheckboxTree)
Vue.component(SpeakolAnalyticsCard.name, SpeakolAnalyticsCard)
Vue.component(SpeakolConfirmationPopup.name, SpeakolConfirmationPopup)
Vue.component(SpeakolResponsePopup.name, SpeakolResponsePopup)
Vue.component(SpeakolBiddingConfirmationPopup.name, SpeakolBiddingConfirmationPopup)
Vue.component(SpeakolChoroplethMap.name, SpeakolChoroplethMap)
Vue.component(SpeakolChartFilter.name, SpeakolChartFilter)


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: createElement => createElement('vs-icon', {
      props: {
        icon: 'speakol-arrow-down-2',
        iconPack: 'speakol',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
